import { timedTier } from "@/campaigns/modules/jackpot/types";

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

/** "2h 39m" above an hour (a daily round's cooldown), "23m" above five minutes, "4:32" below it
 *  (seconds matter once they are what is left). */
export function countdownLabel(
  ms: number,
  t: (key: string, fallback: string, opts?: Record<string, unknown>) => string
): string {
  const clamped = Math.max(0, ms);
  const minutes = Math.floor(clamped / MINUTE_MS);
  const seconds = Math.floor((clamped % MINUTE_MS) / 1000);
  if (clamped >= HOUR_MS) {
    return t("sprintMission.countdownHours", "{{hours}}h {{minutes}}m", {
      hours: Math.floor(clamped / HOUR_MS),
      minutes: minutes % 60,
    });
  }
  if (timedTier(clamped) === "calm") {
    return t("sprintMission.countdownMinutes", "{{minutes}}m", { minutes });
  }
  return t("jackpot.countdownMs", "{{minutes}}:{{seconds}}", {
    minutes,
    seconds: String(seconds).padStart(2, "0"),
  });
}
